import { call, put } from "redux-saga/effects";
import { resetApiError, riseError } from "store/features/general/general.actions";
import { getTemplates, deleteTemplate as deleteTemplateAPI, Template, getUserGroups, UserGroup } from "api";
import { deleteTemplate, fetchTemplates } from "./overview.actions";

export function* fetchTemplatesSaga(headers: HeadersInit): Generator {
    try {
        const templates = (yield call(getTemplates, headers)) as Template[];
        const userGroups = (yield call(getUserGroups, headers)) as UserGroup[];
        yield put(fetchTemplates.success({ templates, userGroups }));
    } catch (err) {
        if (err.status) {
            yield put(fetchTemplates.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}

export function* deleteTemplateSaga(
    headers: HeadersInit,
    action: ReturnType<typeof deleteTemplate.request>
): Generator {
    try {
        yield call(deleteTemplateAPI, action.payload, headers);
        yield put(deleteTemplate.success());
        yield call(fetchTemplatesSaga, headers);
    } catch (err) {
        if (err.status) {
            yield put(deleteTemplate.failure({ statusCode: err.status }));
            yield put(resetApiError());

            return;
        }

        yield put(riseError(err));
    }
}
